const steps = [
  {
    n: '01',
    title: 'Recherchez',
    desc: 'Choisissez une spécialité et un quartier de Rabat. Ajoutez votre code partenaire si vous en avez un.',
    icon: 'ri-search-2-line',
  },
  {
    n: '02',
    title: 'Comparez',
    desc: 'Les praticiens s\'affichent selon leur proximité et leur disponibilité réelle sur les 7 prochains jours.',
    icon: 'ri-list-check-2',
  },
  {
    n: '03',
    title: 'Réservez',
    desc: 'Un clic sur le créneau souhaité — votre RDV s\'écrit directement dans l\'agenda du praticien.',
    icon: 'ri-calendar-check-line',
  },
  {
    n: '04',
    title: 'Recevez la confirmation',
    desc: 'Notification WhatsApp immédiate. Rappel automatique la veille du rendez-vous.',
    icon: 'ri-whatsapp-line',
  },
];

export default function HowItWorks() {
  return (
    <section id="comment" className="py-20 md:py-28 bg-background-100 relative overflow-hidden">
      <div className="absolute top-20 right-0 w-96 h-96 rounded-full bg-primary-200/40 blur-3xl" />
      <div className="absolute bottom-0 left-10 w-80 h-80 rounded-full bg-accent-200/30 blur-3xl" />

      <div className="relative px-4 md:px-8 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-3">
            Le parcours patient
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight mb-4">
            De la recherche au RDV, <span className="italic text-accent-800">4 étapes.</span>
          </h2>
          <p className="text-foreground-600 text-base md:text-lg">
            Aucun agenda intermédiaire. Aucun appel téléphonique. Aucun compte requis pour chercher.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s) => (
            <div key={s.n} className="relative bg-background-50 border border-background-200 rounded-2xl p-6 hover:border-primary-300 transition-colors">
              <div className="flex items-center justify-between mb-5">
                <span className="font-heading text-3xl font-semibold text-primary-500">{s.n}</span>
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-50">
                  <i className={`${s.icon} text-xl text-primary-700 w-5 h-5 flex items-center justify-center`} />
                </div>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">{s.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-3xl mx-auto p-6 md:p-8 rounded-2xl bg-secondary-50 border border-secondary-200 flex flex-col md:flex-row items-start md:items-center gap-5">
          <div className="w-14 h-14 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-500">
            <i className="ri-notification-badge-line text-2xl text-background-50 w-6 h-6 flex items-center justify-center" />
          </div>
          <div className="flex-1">
            <h4 className="font-heading font-semibold text-foreground-950 mb-1"><a href="#faq" className="cursor-pointer">Aucun créneau disponible ?</a></h4>
            <p className="text-sm text-foreground-700 leading-relaxed">
              La plateforme élargit automatiquement la recherche aux praticiens équivalents les plus proches,
              ou vous propose une <strong className="text-secondary-800">liste d'attente</strong> avec alerte dès qu'une annulation libère un créneau.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}